// extracted by mini-css-extract-plugin
export default {"root":"GroupLabel_root__dOzfx"};